<p>Der Anfrage zugeordnete Dokumente:</p>

<clr-datagrid [clrDgLoading]="loading" *transloco="let t; prefix: 'pages.project'">
  <clr-dg-column [clrDgField]="'description'">{{ t('fileDescription') }}</clr-dg-column>
  <clr-dg-column [clrDgField]="'fileName'">{{ t('fileName') }}</clr-dg-column>
  <clr-dg-column [clrDgField]="'document_type'">{{ t('documentType') }}</clr-dg-column>
  <clr-dg-column [clrDgField]="'fileType'">{{ t('fileType') }}</clr-dg-column>
  <clr-dg-column [clrDgField]="'time'">{{ t('uploadDate') }}</clr-dg-column>
  <clr-dg-column></clr-dg-column>

  <clr-dg-placeholder>Keine Dateien zu dieser Anfrage vorhanden!</clr-dg-placeholder>

  <clr-dg-row *clrDgItems="let files of requestsFiles" [clrDgItem]="files">
    <clr-dg-action-overflow>
      <button class="action-item" *ngIf="files.fileType === 'application/pdf'" (click)="showModal(files.id, files.description)">Show PDF</button>
      <button class="action-item" (click)="loadFile(files.id, files.fileName)">Download</button>
    </clr-dg-action-overflow>
    <clr-dg-cell>{{ files.description }}</clr-dg-cell>
    <clr-dg-cell>{{ files.fileName }}</clr-dg-cell>
    <clr-dg-cell>{{ t( 'docTypes' + '.' + files.document_type.toString() ) }}</clr-dg-cell>
    <clr-dg-cell>{{ files.fileType }}</clr-dg-cell>
    <clr-dg-cell>{{ files.time }}</clr-dg-cell>
    <clr-dg-cell>
      <cds-icon shape="times-circle" class="is-solid" (click)="deleteFile(files.id, files.fileName)"></cds-icon>&nbsp;
    </clr-dg-cell>
  </clr-dg-row>
</clr-datagrid><br />
<button *ngIf="!showFileUpload" class="btn btn-primary btn-sm" (click)="showFileUploader()">Datei hochladen</button>
<br />
<div *ngIf="showFileUpload">
  <h3>Datei für diesen Request hinzufügen</h3>
  <app-upload [companyId]=0 [componentId]="'0'" [projectId]=projectId [jobId]=0 [subId]=requestId [docType]=10 (closeModalEvent)="closeModal($event)"></app-upload>
</div>

<ng-container *ngIf="showPdf">
  <clr-modal id="pdfViewer" [(clrModalOpen)]="showPdf" [clrModalStaticBackdrop]="false">
    <h3 class="modal-title">{{ modalContent }} Directory: {{ modalUrl }}</h3>
    <div class="modal-body">
      <ngx-extended-pdf-viewer [src]="modalUrl" useBrowserLocale="true" height="85vh" [textLayer]="true"></ngx-extended-pdf-viewer>
    </div>
  </clr-modal>
</ng-container>
